// extracted by mini-css-extract-plugin
export var container = "fullImageTextBlock-module--container--7j2zL";
export var imageContainer = "fullImageTextBlock-module--imageContainer--lmEmr";
export var textContainer = "fullImageTextBlock-module--textContainer--+FBOd";
export var title = "fullImageTextBlock-module--title--7+ZgM";
export var bgImage = "fullImageTextBlock-module--bgImage--lypF4";